import { IsBoolean, IsDefined, IsNumber, IsOptional } from 'class-validator';
import { EdiConnectionType } from '../../enum/edi';
import { EdiConnectionDetails } from '../../models';

export class EdiIntegrationCreateRequestDto {
  @IsNumber()
  supplierId: number;

  @IsNumber()
  merchantId: number;

  @IsNumber()
  messageTypeId: number;

  @IsOptional()
  @IsBoolean()
  enabled: boolean = false;

  @IsOptional()
  @IsBoolean()
  sendEmail: boolean = false;

  @IsOptional()
  @IsBoolean()
  requireOrderConfirmation?: boolean = false;

  @IsDefined()
  connectionType: EdiConnectionType;

  @IsDefined()
  connectionDetails: EdiConnectionDetails;
}
